import React, { FC } from "react";
import { IonIcon } from "@ionic/react";

import { GearboxTemplate } from "../../state";
import boxIcon from "../../assets/icons/box.svg";

import styles from "./BoxTemplate.module.scss";

type Props = {
  title: string;
  boxTemplate: GearboxTemplate;
};

const BoxTemplate: FC<Props> = ({ title, boxTemplate }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>
        <IonIcon className={styles.icon} src={boxIcon} />
        {title}
      </p>
      <p className={styles.content}>{boxTemplate.content}</p>
    </div>
  );
};

export default BoxTemplate;
